import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, createVNode as _createVNode } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = { class: "table table-sm" }
const _hoisted_3 = { style: {"vertical-align":"middle"} }
const _hoisted_4 = { style: {"vertical-align":"middle"} }
const _hoisted_5 = { style: {"vertical-align":"middle"} }
const _hoisted_6 = { style: {"vertical-align":"middle"} }
const _hoisted_7 = {
  class: "text-center",
  style: {"vertical-align":"middle"}
}
const _hoisted_8 = { class: "d-flex gap-1" }

import ModalContent from '@/components/ModalContent.vue';
    import { CompanyService} from '@/services/backend/ApiService';
    import UserService from '@/services/OnlineUserService'
    import router from '@/router';
    import { isAdmin, isMetroUser } from '../../../../zabbix-shared/utils/user';
    import { onMounted, ref } from 'vue';
    import { ICompany } from '../../../../zabbix-shared/interfaces/intefaces';
    
    
export default /*@__PURE__*/_defineComponent({
  __name: 'CompaniesList',
  setup(__props) {

    let user = ref();
    const companies = ref<ICompany[]>([]);
    const isDeleteModalOpened = ref(false);

    const addCompany = async () => {
      let newCompany: ICompany = {} as ICompany;
      newCompany = await CompanyService.create(newCompany);
      companies.value.push(newCompany);
    };

    const deleteCompany = async (company: ICompany) => {
      try {
        isDeleteModalOpened.value = false;
        await CompanyService.delete(company.id);
        companies.value = companies.value.filter(site => site.id !== company.id);
      } catch (error) {
        console.error('Erro ao excluir a empresa:', error);
      }
    };

    const closeModal = async () => {
      isDeleteModalOpened.value = false;
    };

    const saveChanges = async () => {
      try {
        console.log('Salvando mudanças...');
      } catch (error) {
        console.error('Erro ao salvar as mudanças:', error);
      }
    };

    onMounted(async () => {
      companies.value = await CompanyService.findAll();
      user.value = await UserService.waitForUser();
      if (!isMetroUser(user.value)) {
        router.push("empresas/" + user.value.company.id);
      }
    });

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _cache[6] || (_cache[6] = _createElementVNode("div", { class: "title bg-success" }, "Empresas Noc", -1)),
    (_unref(user))
      ? (_openBlock(), _createElementBlock("fieldset", _hoisted_1, [
          _createElementVNode("table", _hoisted_2, [
            _cache[5] || (_cache[5] = _createElementVNode("thead", { class: "table-light" }, [
              _createElementVNode("tr", null, [
                _createElementVNode("th", {
                  scope: "col",
                  class: "col-id"
                }, "ID"),
                _createElementVNode("th", {
                  scope: "col",
                  class: "col-site"
                }, "Empresa"),
                _createElementVNode("th", {
                  scope: "col",
                  class: "col-site"
                }, "Telefone"),
                _createElementVNode("th", {
                  scope: "col",
                  class: "col-site"
                }, "Email"),
                _createElementVNode("th", {
                  scope: "col",
                  class: "col-actions"
                }, "Ações")
              ])
            ], -1)),
            _createElementVNode("tbody", null, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(companies.value, (site) => {
                return (_openBlock(), _createElementBlock("tr", {
                  key: site.id
                }, [
                  _createElementVNode("td", _hoisted_3, _toDisplayString(site.id), 1),
                  _createElementVNode("td", _hoisted_4, _toDisplayString(site.name), 1),
                  _createElementVNode("td", _hoisted_5, _toDisplayString(site.phone), 1),
                  _createElementVNode("td", _hoisted_6, _toDisplayString(site.email), 1),
                  _createElementVNode("td", _hoisted_7, [
                    _createElementVNode("div", _hoisted_8, [
                      (_unref(isAdmin)(_unref(user)))
                        ? (_openBlock(), _createBlock(_component_router_link, {
                            key: 0,
                            to: `/empresas/${site.id}?mode=edit`
                          }, {
                            default: _withCtx(() => _cache[2] || (_cache[2] = [
                              _createElementVNode("a", {
                                type: "button",
                                class: "actions btn btn-secondary btn-sm"
                              }, " Editar ", -1)
                            ])),
                            _: 2
                          }, 1032, ["to"]))
                        : _createCommentVNode("", true),
                      (!_unref(isAdmin)(_unref(user)))
                        ? (_openBlock(), _createBlock(_component_router_link, {
                            key: 1,
                            to: `/empresas/${site.id}?mode=view`
                          }, {
                            default: _withCtx(() => _cache[3] || (_cache[3] = [
                              _createElementVNode("a", {
                                type: "button",
                                class: "actions btn btn-info btn-sm"
                              }, " Visualizar ", -1)
                            ])),
                            _: 2
                          }, 1032, ["to"]))
                        : _createCommentVNode("", true),
                      (_unref(isAdmin)(_unref(user)))
                        ? (_openBlock(), _createElementBlock("a", {
                            key: 2,
                            onClick: _cache[0] || (_cache[0] = ()=> isDeleteModalOpened.value = true),
                            type: "button",
                            class: "actions btn btn-danger btn-sm"
                          }, " Excluir "))
                        : _createCommentVNode("", true),
                      _createVNode(ModalContent, {
                        "is-modal-open": isDeleteModalOpened.value,
                        onClose: _cache[1] || (_cache[1] = () => isDeleteModalOpened.value = false),
                        onSend: ($event: any) => (deleteCompany(site)),
                        title: `Excluir empresa ?`
                      }, {
                        default: _withCtx(() => _cache[4] || (_cache[4] = [
                          _createTextVNode("Você tem certeza que deseja excluir essa empresa ? ")
                        ])),
                        _: 2
                      }, 1032, ["is-modal-open", "onSend"])
                    ])
                  ])
                ]))
              }), 128))
            ])
          ]),
          (_unref(isMetroUser)(_unref(user)) && _unref(isAdmin)(_unref(user)))
            ? (_openBlock(), _createElementBlock("button", {
                key: 0,
                onClick: addCompany,
                type: "button",
                class: "mx-auto actions btn btn-primary btn-sm"
              }, " Adicionar "))
            : _createCommentVNode("", true)
        ]))
      : _createCommentVNode("", true)
  ], 64))
}
}

})